import React from 'react';
import styles from './error.module.scss';
import PrimaryButton from '../buttons/PrimaryButton';
import { useTranslation } from 'react-i18next';
import FeatherIcon from "feather-icons-react";

interface IProps {
    finishConnection: () => void;
    oldConsentEndDate: Date | undefined;
}

const ReAuthenticateCancelled: React.FC<IProps> = (props: IProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.screen} data-testid='error-container'>
            <div className={styles.topWrapper}>
                <FeatherIcon icon="x" className={styles.icon} />
                <h1>{t<string>('Bank access refresh cancelled')}</h1>
                {props.oldConsentEndDate ? (
                <>
                <div className={styles.content}>
                    {t<string>('Access to your bank data has not been changed and will expire on the following date:')}
                </div>
                <div className={`${styles.bottomContent} ${styles.thick}`}>
                    {props.oldConsentEndDate?.toLocaleDateString(navigator.language, {
                        year: 'numeric',
                        month: 'long',
                        day: '2-digit',
                    })}
                </div>
                </>
                ):(
                <div className={styles.content}>
                    {t<string>('Access to your bank data has not been changed.')}
                </div>
                )}
            </div>
            <div className={styles.buttonWrapper}>
                <PrimaryButton onClick={props.finishConnection}>{t<string>('Quit')}</PrimaryButton>
            </div>
        </div>
    );
};

export default ReAuthenticateCancelled;
